import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu } from '../../../../../../shared/menu/menu'
import { useUserMenuItems } from './user-menu-items'

// The user page's menu: the Users row menu's items, less Edit (this page).
export const HeaderMenu = () => {
  const { userID } = useParamsInt()
  const userMenuItems = useUserMenuItems()

  return <Menu>{userMenuItems(userID)}</Menu>
}
